export const CALENDAR_TIMETABLE_TAG_TYPE = "CalendarTimetable" as const;

/**
 * Tag záznamu `getTimetable` pro daný rozsah. Id je rozsah, takže invalidace zasáhne jen záznam s týmiž
 * argumenty (kalendář), ne týdenní dotaz `useTimetableData` s jiným rozsahem. Rozsah kalendáře musí být
 * z `getCalendarRange`, jinak se tag netrefí. [TD-476]
 */
export const calendarTimetableTag = ({ dateFrom, dateTo }: { dateFrom: string; dateTo: string }) => ({
  type: CALENDAR_TIMETABLE_TAG_TYPE,
  id: `${dateFrom}..${dateTo}`,
});
